import { useReducer, useEffect, type Dispatch } from "react";
import { VendorDataCollection } from "../models";
import { type VendorDataItem } from "../../gql-generated";
import { type VendorDataChangedAction } from "../vendorDataReducer";
import { vendorDataReducer } from "..";

export const useVendorData = (
    vendorData: readonly VendorDataItem[],
): [VendorDataCollection, Dispatch<VendorDataChangedAction>] => {
    const [vendorDataCollection, dispatch] = useReducer(
        vendorDataReducer,
        vendorData,
        (data) => new VendorDataCollection(data),
    );

    useEffect(() => {
        if (vendorData && vendorData.length > 0) {
            dispatch({ type: "replace", entries: vendorData });
        }
    }, [vendorData]);

    return [vendorDataCollection, dispatch];
};
